import { render, staticRenderFns } from "./waybillList.vue?vue&type=template&id=997b8aac&scoped=true&"
import script from "./waybillList.vue?vue&type=script&lang=js&"
export * from "./waybillList.vue?vue&type=script&lang=js&"
import style0 from "./waybillList.vue?vue&type=style&index=0&id=997b8aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997b8aac",
  null
  
)

export default component.exports